import React from 'react';
import MenuMobile from './MenuMobile';
import FooterLinks from './FooterLinks';
import FooterCart from './FooterCart';

const Footer = () => {
    return (
        <section className='flex flex-col w-full'>

            {/* <ButtonScrollToTop /> */}

            <FooterLinks />

            {/* MENU/CART MOBILE */}
            <section className='fixed md:hidden z-30 w-full h-16 bottom-0'>
                <FooterCart />
                <MenuMobile />
            </section>

        </section>
    );
};

export default Footer;
